var render = function render(){var _vm=this,_c=_vm._self._c;return _c('WireframeNested',{attrs:{"title":"Настройки"}},[_c('LayoutOneColumn',{staticClass:"pa-2"},[_c('v-switch',{attrs:{"label":"Темная тема","inset":""},model:{value:(_vm.$store.settings.isThemeDark.value),callback:function ($$v) {_vm.$set(_vm.$store.settings.isThemeDark, "value", $$v)},expression:"$store.settings.isThemeDark.value"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }